import { useQuery } from '@eika-infrastruktur/react-query';

import { WispSignalResponse } from '../generated-types';
import getWispSignal from '../services/wispSignalService';

const TEN_MINUTES = 1000 * 60 * 10;

const useWispSignal = () => {
    return useQuery<WispSignalResponse>({
        queryKey: ['wispSignal'],
        queryFn: getWispSignal,
        staleTime: TEN_MINUTES,
    });
};

export default useWispSignal;
